const rankingItems = [
  { rank: 1, title: '绝世武神', type: '玄幻', heat: '9.9', tag: '韩漫' },
  { rank: 2, title: '甜蜜暴击', type: '恋爱', heat: '9.8', tag: '国漫' },
  { rank: 3, title: '炎之轨迹', type: '热血', heat: '9.7', tag: '日漫' },
  { rank: 4, title: '重生之都市仙尊', type: '穿越', heat: '9.6', tag: '韩漫' },
  { rank: 5, title: '暗夜侦探录', type: '悬疑', heat: '9.5', tag: '国漫' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-[360px] flex-shrink-0">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">排行榜</h2>
            <p className="text-sm text-foreground-500 mb-6">实时热度排名，发现最受欢迎的漫画</p>
            <div className="flex flex-wrap gap-2">
              <span className="px-4 py-2 rounded-full bg-primary-500 text-background-50 text-xs font-semibold cursor-pointer whitespace-nowrap">热度榜</span>
              <span className="px-4 py-2 rounded-full bg-background-200 text-foreground-600 text-xs font-semibold cursor-pointer whitespace-nowrap">新作榜</span>
              <span className="px-4 py-2 rounded-full bg-background-200 text-foreground-600 text-xs font-semibold cursor-pointer whitespace-nowrap">完结榜</span>
            </div>
          </div>
          <div className="flex-1 space-y-3">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-primary-50/60 transition-colors cursor-pointer"
              >
                <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg font-black text-sm ${
                  item.rank === 1 ? 'bg-accent-500 text-background-50' :
                  item.rank === 2 ? 'bg-primary-500 text-background-50' :
                  item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                  'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm font-bold text-foreground-800 whitespace-nowrap">{item.title}</h3>
                    <span className="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-semibold whitespace-nowrap">{item.tag}</span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.type}</p>
                </div>
                <div className="flex items-center gap-1 text-accent-500 font-bold text-sm whitespace-nowrap">
                  <i className="ri-fire-line"></i>
                  {item.heat}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}